import React, { FC } from 'react';
import { useForm } from 'react-hook-form';
import { ISelectOptionProps } from 'components/form/types';
import { useModal } from 'store/modal';
import { buildClientEntity, buildClientUrl } from 'utils/helpers/client';
import { useActiveClientContext } from 'store/active-client';
import CreateEntity from 'components/crud/CreateEntity';
import { useTranslation } from 'react-i18next';
import EmployeeForm from '../../components/EmployeeForm';
import EmployeeFormMulti from '../../components/EmployeeFormMulti';
import { IDropdowns, IInputs } from '../../components/types';
import { formatDataOnSubmit } from '../../dataFormatters';

interface IProps {
  roleOptions: ISelectOptionProps[];
  userDataOptions: IDropdowns;
}

const CreateForm: FC<IProps> = ({ roleOptions, userDataOptions }: IProps) => {
  const { t } = useTranslation();
  const { showModal } = useModal();
  const { client } = useActiveClientContext();

  const groups = userDataOptions.group.filter(gr => gr.selected);

  const methods = useForm<IInputs>({
    defaultValues: {
      groups,
    },
  });

  return (
    <CreateEntity
      entity="users"
      methods={methods}
      onSuccess={(res: any) => {
        const { first_name: firstName, last_name: lastName } = res.data;
        showModal({
          type: 'success',
          content: (
            <>
              {t('structure.employees.createSuccessMsg')}&nbsp;
              <span className="font-weight-bold text-break">
                {firstName} {lastName}
              </span>
              .
            </>
          ),
        });
      }}
      queryKey={[buildClientEntity('users', client), buildClientEntity('user', client)]}
      onSuccessPushToLink={buildClientUrl('/structure/employees', client)}
    >
      {(create: any) =>
        userDataOptions.is_multilingual ? (
          <EmployeeFormMulti
            title={t('structure.employees.createTitle')}
            methods={methods}
            handleSubmit={data => create(formatDataOnSubmit(data))}
            btnLabel={t('common.save')}
            roleOptions={roleOptions}
            client={client}
            userDataOptions={userDataOptions}
          />
        ) : (
          <EmployeeForm
            title={t('structure.employees.createTitle')}
            methods={methods}
            handleSubmit={data => create(formatDataOnSubmit(data))}
            client={client}
            btnLabel={t('common.save')}
            roleOptions={roleOptions}
            userDataOptions={userDataOptions}
          />
        )
      }
    </CreateEntity>
  );
};

export default CreateForm;
